module.exports = __webpack_public_path__ + "static/media/Absa-sme.736b8168.jpg";